module.exports = __webpack_public_path__ + "media/lendingtree/female-student-reading-f8da4600.jpg";